"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[494],{

/***/ 48982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Filter_Filter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Radio/Radio.tsx + 1 modules
var Radio = __webpack_require__(45147);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
;// CONCATENATED MODULE: ./src/utils/string.utils.ts
var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var removeAccents = function removeAccents(string) {
  var strAccents = string.split('');
  var strAccentsOut = [];
  var strAccentsLen = strAccents.length;
  var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëÇçðÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  var accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeCcdDIIIIiiiiUUUUuuuuNnSsYyyZz';

  for (var y = 0; y < strAccentsLen; y++) {
    if (accents.indexOf(strAccents[y]) != -1) {
      strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
    } else strAccentsOut[y] = strAccents[y];
  }

  strAccentsOut = strAccentsOut.join('');
  return strAccentsOut;
};
// EXTERNAL MODULE: ./src/interfaces/Filter.ts
var Filter = __webpack_require__(81057);
// EXTERNAL MODULE: ./src/ui/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(26208);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Filter/Filter.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Wrapper",
  componentId: "sc-17epv0c-0"
})(["padding:", ";width:", ";border-bottom:", ";margin:0 auto ", " auto;padding:", " ", " ", " ", ";@media (min-width:", "px){width:calc(100% - 60px);}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(320), function (props) {
  return props.withBorderBottom ? "1px solid ".concat(props.theme.colors.border) : 'unset';
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Title",
  componentId: "sc-17epv0c-1"
})(["font-weight:", ";font-size:", ";padding-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(25));
var Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Group",
  componentId: "sc-17epv0c-2"
})(["font-weight:", ";padding-top:", ";padding-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10));
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Line",
  componentId: "sc-17epv0c-3"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(2));
var InLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__InLine",
  componentId: "sc-17epv0c-4"
})(["padding:", " ", ";"], (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(30));
var Search = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Search",
  componentId: "sc-17epv0c-5"
})(["display:flex;background:", ";padding:", ";position:relative;border:1px solid ", ";border-radius:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(10), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8));
var Filter_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Filterelements__Icon",
  componentId: "sc-17epv0c-6"
})(["svg{width:", ";height:", ";margin:", " ", " 0 0;path{fill:", ";opacity:0.6;}@media (min-width:", "px){margin-right:", ";}}"], (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(5), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grey;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(10));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Filterelements__Input",
  componentId: "sc-17epv0c-7"
})(["width:100%;border:none;color:", ";&::placeholder{font-weight:", ";opacity:0.6;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.black;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
});
var SearchResults = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__SearchResults",
  componentId: "sc-17epv0c-8"
})(["position:absolute;top:", ";background:", ";left:0;padding:", " ", ";border:1px solid ", ";border-radius:", ";"], (0,polished_esm/* rem */.hO)(51), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8));
var SearchResult = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Filterelements__SearchResult",
  componentId: "sc-17epv0c-9"
})(["display:block;color:", ";cursor:pointer;padding:", " 0;&:hover{color:", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.dark;
}, (0,polished_esm/* rem */.hO)(10), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
});
var SelectedResults = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__SelectedResults",
  componentId: "sc-17epv0c-10"
})([""]);
var SelectedResult = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Filterelements__SelectedResult",
  componentId: "sc-17epv0c-11"
})(["display:block;background:", ";padding:", ";margin:", " 0;color:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.dark;
});
var RemoveResult = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Filterelements__RemoveResult",
  componentId: "sc-17epv0c-12"
})(["font-weight:", ";padding:0 10px;cursor:pointer;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeights.textBold;
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filterelements__Item",
  componentId: "sc-17epv0c-13"
})([""]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Filter/Filter.tsx

















var FilterTemplate = function FilterTemplate(_ref) {
  var _split, _searchInputRef$curre2, _searchInputRef$curre3, _ref3, _ref3$sort, _data$filter3;

  var name = _ref.name,
      _ref$isLecturer = _ref.isLecturer,
      isLecturer = _ref$isLecturer === void 0 ? false : _ref$isLecturer,
      data = _ref.data,
      type = _ref.type,
      courseTypeCounts = _ref.courseTypeCounts,
      conferenceTypeCounts = _ref.conferenceTypeCounts,
      withBorderBottom = _ref.withBorderBottom;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.CITY */.$R.CITY]),
      selectedCities = _useState[0],
      setSelectedCities = _useState[1];

  var _useState2 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.MONTH */.$R.MONTH]),
      selectedMonths = _useState2[0],
      setSelectedMonths = _useState2[1];

  var _useState3 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.PACKAGES */.$R.PACKAGES]),
      selectedPackages = _useState3[0],
      setSelectedPackages = _useState3[1];

  var _useState4 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.TRAINING_TYPE */.$R.TRAINING_TYPE]),
      selectedTrainingTypes = _useState4[0],
      setSelectedTrainingTypes = _useState4[1];

  var _useState5 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.CONFERENCE_TYPE */.$R.CONFERENCE_TYPE] || Filter/* ConferenceTypes.UPCOMING */.sP.UPCOMING),
      selectedConferenceTypes = _useState5[0],
      setSelectedConferenceTypes = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      selectedParentCategories = _useState6[0],
      setSelectedParentCategories = _useState6[1];

  var _useState7 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY]),
      selectedCategories = _useState7[0],
      setSelectedCategories = _useState7[1];

  var _useState8 = (0,react.useState)(router.query[Filter/* FilterTypesInUrl.LECTURER */.$R.LECTURER]),
      selectedLecturers = _useState8[0],
      setSelectedLecturers = _useState8[1];

  var _useState9 = (0,react.useState)(null),
      searchLecturers = _useState9[0],
      setSearchLecturers = _useState9[1];

  var searchInputRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    setSelectedCities(router.query[Filter/* FilterTypesInUrl.CITY */.$R.CITY]);
    setSelectedMonths(router.query[Filter/* FilterTypesInUrl.MONTH */.$R.MONTH]);
    setSelectedPackages(router.query[Filter/* FilterTypesInUrl.PACKAGES */.$R.PACKAGES]);
    setSelectedTrainingTypes(router.query[Filter/* FilterTypesInUrl.TRAINING_TYPE */.$R.TRAINING_TYPE] || Filter/* CourseTypes.UPCOMING */.fz.UPCOMING);
    setSelectedConferenceTypes(router.query[Filter/* FilterTypesInUrl.CONFERENCE_TYPE */.$R.CONFERENCE_TYPE] || Filter/* ConferenceTypes.UPCOMING */.sP.UPCOMING);
    setSelectedCategories(router.query[Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY]);
    setSearchLecturers(router.query[Filter/* FilterTypesInUrl.LECTURER */.$R.LECTURER]);
  }, [router.query]);

  var updateUrlParameters = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(newValue, type, previousValues, updateValues, parentCategory, childrenCategories) {
      var _arrValues$filter;

      var query, arrValues, _query$type, _query$type2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = router.query;
              delete query.strana;
              arrValues = previousValues ? previousValues === null || previousValues === void 0 ? void 0 : previousValues.split(',') : []; // Add or remove category if it has not a parent

              if (!parentCategory && (arrValues === null || arrValues === void 0 ? void 0 : (_arrValues$filter = arrValues.filter(function (category) {
                return childrenCategories === null || childrenCategories === void 0 ? void 0 : childrenCategories.includes(category);
              })) === null || _arrValues$filter === void 0 ? void 0 : _arrValues$filter.length) === 0) {
                arrValues.includes(newValue) ? query[type] = arrValues.filter(function (city) {
                  return city !== newValue;
                }).join(',') : query[type] = [].concat((0,toConsumableArray/* default */.Z)(arrValues), [newValue]).join(',');
              } // Add or remove category if it has a parent


              if (parentCategory) {
                arrValues.includes(newValue) ? query[type] = arrValues.filter(function (city) {
                  return city !== newValue;
                }).join(',') : query[type] = [].concat((0,toConsumableArray/* default */.Z)(arrValues), [newValue]).join(',');
              } // Remove all children if parent was unselected


              if (query[type] && type === Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY && childrenCategories) {
                query[type] = (_query$type = query[type]) === null || _query$type === void 0 ? void 0 : _query$type.split(',').filter(function (category) {
                  return !childrenCategories.includes(category);
                }).join(',');
              } // Remove parent category if child was selected


              if (query[type] && type === Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY && parentCategory) {
                query[type] = (_query$type2 = query[type]) === null || _query$type2 === void 0 ? void 0 : _query$type2.split(',').filter(function (category) {
                  return category !== parentCategory;
                }).join(',');
              }

              updateValues(query[type]);
              if (!query[type]) delete query[type];
              return _context.abrupt("return", router.push({
                pathname: router.pathname,
                query: query
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateUrlParameters(_x, _x2, _x3, _x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();

  var search = function search() {
    var _searchInputRef$curre;

    var searchInput = searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.value;

    if ((searchInput === null || searchInput === void 0 ? void 0 : searchInput.length) >= 3) {
      setSearchLecturers(data === null || data === void 0 ? void 0 : data.filter(function (lecturer) {
        return removeAccents((0,person_utils/* formatLecturerName */.v)(lecturer).toLowerCase()).includes(removeAccents(searchInput === null || searchInput === void 0 ? void 0 : searchInput.toLowerCase()));
      }));
    } else {
      setSearchLecturers(null);
    }
  };

  (0,react.useEffect)(function () {
    if (type === Filter/* FilterTypesInResponse.CATEGORY */.N_.CATEGORY) {
      var selectedParentCategoriesArr = [];
      data.map(function (filter) {
        var _children;

        var allChildKeys = filter === null || filter === void 0 ? void 0 : (_children = filter.children) === null || _children === void 0 ? void 0 : _children.map(function (child) {
          return child._key;
        });
        var selectedChildKeys = selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.split(',');

        if (!!(selectedChildKeys !== null && selectedChildKeys !== void 0 && selectedChildKeys.find(function (selectedKey) {
          return allChildKeys.includes(selectedKey);
        }))) {
          selectedParentCategoriesArr.push(filter._key);
        }
      });
      setSelectedParentCategories(selectedParentCategoriesArr);
    }
  }, [selectedCategories]);

  var removeSelectedParentCategory = function removeSelectedParentCategory(removedCategoryKey) {
    var _find, _find$children;

    var query = router.query;
    setSelectedParentCategories(selectedParentCategories.filter(function (key) {
      return key !== removedCategoryKey;
    }));
    var selectedChildrenKeys = (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.split(',')) || [];
    var parentCategory = data.find(function (filter) {
      return filter._key === removedCategoryKey;
    });
    var parentChildrenKeys = parentCategory.children.map(function (child) {
      return child._key;
    });
    var updatedChildrenKeys = selectedChildrenKeys.filter(function (selectedCategory) {
      return !parentChildrenKeys.includes(selectedCategory);
    });

    if ((updatedChildrenKeys === null || updatedChildrenKeys === void 0 ? void 0 : updatedChildrenKeys.length) === 0) {
      delete query[Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY];
    } else {
      query[Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY] = updatedChildrenKeys.join(',');
    }

    var removedChildCategories = (data === null || data === void 0 ? void 0 : (_find = data.find(function (category) {
      return category._key === removedCategoryKey;
    })) === null || _find === void 0 ? void 0 : (_find$children = _find.children) === null || _find$children === void 0 ? void 0 : _find$children.map(function (category) {
      return category._key;
    })) || [];
    setSelectedCategories(((selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.split(',')) || []).filter(function (selectedCategory) {
      return !removedChildCategories.includes(selectedCategory);
    }).join(','));
    return router.push({
      pathname: router.pathname,
      query: query
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    withBorderBottom: withBorderBottom,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    }), isLecturer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectedResults, {
        children: (selectedLecturers === null || selectedLecturers === void 0 ? void 0 : selectedLecturers.length) > 0 && (selectedLecturers === null || selectedLecturers === void 0 ? void 0 : (_split = selectedLecturers.split(',')) === null || _split === void 0 ? void 0 : _split.map(function (selectedLecturerKey) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectedResult, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RemoveResult, {
              onClick: function onClick() {
                updateUrlParameters(selectedLecturerKey, Filter/* FilterTypesInUrl.LECTURER */.$R.LECTURER, selectedLecturers, setSelectedLecturers);
                searchInputRef.current.value = '';
              },
              children: "X"
            }), (0,person_utils/* formatLecturerName */.v)(data === null || data === void 0 ? void 0 : data.find(function (lecturer) {
              return lecturer._key === selectedLecturerKey;
            }))]
          }, selectedLecturerKey);
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Search, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filter_elements_Icon, {
          name: Icon/* Icons.Search */.PJ.Search
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
          onKeyUp: search,
          ref: searchInputRef,
          placeholder: "Jm\xE9no a p\u0159\xEDjmen\xED"
        }), (searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 ? void 0 : (_searchInputRef$curre3 = _searchInputRef$curre2.value) === null || _searchInputRef$curre3 === void 0 ? void 0 : _searchInputRef$curre3.length) > 0 && (searchLecturers === null || searchLecturers === void 0 ? void 0 : searchLecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(SearchResults, {
          children: searchLecturers.map(function (lecturer, key) {
            var _split2;

            if (!(selectedLecturers !== null && selectedLecturers !== void 0 && (_split2 = selectedLecturers.split(',')) !== null && _split2 !== void 0 && _split2.find(function (selectedLecturerKey) {
              return lecturer._key === selectedLecturerKey;
            }))) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchResult, {
                onClick: function onClick() {
                  updateUrlParameters(lecturer._key, Filter/* FilterTypesInUrl.LECTURER */.$R.LECTURER, selectedLecturers, setSelectedLecturers);
                  searchInputRef.current.value = '';
                },
                children: (0,person_utils/* formatLecturerName */.v)(lecturer)
              }, key);
            }
          })
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [type === Filter/* FilterTypesInResponse.CITY */.N_.CITY && (data === null || data === void 0 ? void 0 : data.map(function (filter, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            name: "city-".concat(filter === null || filter === void 0 ? void 0 : filter._key),
            onChange: function onChange() {
              return updateUrlParameters(filter._key, Filter/* FilterTypesInUrl.CITY */.$R.CITY, selectedCities, setSelectedCities);
            },
            checked: selectedCities === null || selectedCities === void 0 ? void 0 : selectedCities.includes(filter._key),
            label: "".concat(capitalizeFirstLetter(filter.name), " (").concat(filter.count, ")")
          })
        }, "city-".concat(filter._key, "-").concat(key));
      })), type === Filter/* FilterTypesInResponse.PACKAGES */.N_.PACKAGES && (Object === null || Object === void 0 ? void 0 : Object.keys(data).map(function (filter, key) {
        var _data$filter;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            name: "packages-".concat(filter),
            onChange: function onChange() {
              return updateUrlParameters(filter, Filter/* FilterTypesInUrl.PACKAGES */.$R.PACKAGES, selectedPackages, setSelectedPackages);
            },
            checked: selectedPackages === null || selectedPackages === void 0 ? void 0 : selectedPackages.includes(filter),
            label: "".concat(t("filter.package.".concat(filter)), " (").concat(data === null || data === void 0 ? void 0 : (_data$filter = data[filter]) === null || _data$filter === void 0 ? void 0 : _data$filter.count, ")")
          })
        }, "packages-".concat(filter, "-").concat(key));
      })), type === Filter/* FilterTypesInResponse.MONTH */.N_.MONTH && ( // @ts-ignore
      (_ref3 = (0,toConsumableArray/* default */.Z)(new Set(data.map(function (item) {
        return item.year;
      })))) === null || _ref3 === void 0 ? void 0 : (_ref3$sort = _ref3.sort(function (a, b) {
        return a - b;
      })) === null || _ref3$sort === void 0 ? void 0 : _ref3$sort.map(function (year, key) {
        var _data$filter2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Group, {
            children: year
          }), data === null || data === void 0 ? void 0 : (_data$filter2 = data.filter(function (filter) {
            return (filter === null || filter === void 0 ? void 0 : filter.year) === year;
          })) === null || _data$filter2 === void 0 ? void 0 : _data$filter2.map(function (filter, key) {
            var _split3;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "month-".concat(filter === null || filter === void 0 ? void 0 : filter.month, "-").concat(filter === null || filter === void 0 ? void 0 : filter.year),
                onChange: function onChange() {
                  return updateUrlParameters("".concat(filter.month, "-").concat(filter.year), Filter/* FilterTypesInUrl.MONTH */.$R.MONTH, selectedMonths, setSelectedMonths);
                },
                checked: !!(selectedMonths !== null && selectedMonths !== void 0 && (_split3 = selectedMonths.split(',')) !== null && _split3 !== void 0 && _split3.find(function (selectedMonthKey) {
                  return selectedMonthKey === "".concat(filter.month, "-").concat(filter.year);
                })),
                label: "".concat(Filter/* MonthLabels */.eD[String(filter.month)], " (").concat(filter.count, ")")
              })
            }, "month-".concat(filter.month, "-").concat(key));
          })]
        }, key);
      })), type === Filter/* FilterTypesInResponse.CATEGORY */.N_.CATEGORY && (data === null || data === void 0 ? void 0 : (_data$filter3 = data.filter(function (filter) {
        return (filter === null || filter === void 0 ? void 0 : filter.count) > 0;
      })) === null || _data$filter3 === void 0 ? void 0 : _data$filter3.map(function (filter, parentKey) {
        var _split4, _children3;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
              name: "category-".concat(filter === null || filter === void 0 ? void 0 : filter._key),
              onChange: function onChange() {
                var _children2;

                return updateUrlParameters(filter._key, Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY, selectedCategories, setSelectedCategories, null, filter === null || filter === void 0 ? void 0 : (_children2 = filter.children) === null || _children2 === void 0 ? void 0 : _children2.map(function (child) {
                  return child === null || child === void 0 ? void 0 : child._key;
                }));
              },
              checked: !!(selectedCategories !== null && selectedCategories !== void 0 && (_split4 = selectedCategories.split(',')) !== null && _split4 !== void 0 && _split4.find(function (selectedCategoryKey) {
                return selectedCategoryKey === filter._key;
              })) || !!(selectedParentCategories !== null && selectedParentCategories !== void 0 && selectedParentCategories.find(function (selectedCategoryKey) {
                return selectedCategoryKey === filter._key;
              })),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                  __html: "".concat(filter.name.replace(' a ', '</br>a '), " (").concat(filter.count, ")")
                }
              })
            })
          }, "category-".concat(filter._key, "-").concat(parentKey)), ((selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.includes(filter._key)) || !!(selectedParentCategories !== null && selectedParentCategories !== void 0 && selectedParentCategories.find(function (selectedCategoryKey) {
            return selectedCategoryKey === filter._key;
          }))) && (filter === null || filter === void 0 ? void 0 : (_children3 = filter.children) === null || _children3 === void 0 ? void 0 : _children3.map(function (child, childKey) {
            var _split5;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(InLine, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: child._key,
                onChange: function onChange() {
                  return updateUrlParameters(child._key, Filter/* FilterTypesInUrl.CATEGORY */.$R.CATEGORY, selectedCategories, setSelectedCategories, filter === null || filter === void 0 ? void 0 : filter._key);
                },
                checked: !!(selectedCategories !== null && selectedCategories !== void 0 && (_split5 = selectedCategories.split(',')) !== null && _split5 !== void 0 && _split5.find(function (selectedCategoryKey) {
                  return selectedCategoryKey === child._key;
                })),
                label: "".concat(child.name, " (").concat(child.count, ")")
              })
            }, "children-category-".concat(child._key, "-").concat(childKey));
          }))]
        }, "cat-".concat(filter._key, "-").concat(parentKey));
      })), type === Filter/* FilterTypesInResponse.TRAINING_TYPE */.N_.TRAINING_TYPE && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, {
            name: Filter/* CourseTypes.UPCOMING */.fz.UPCOMING,
            onChange: function onChange() {
              return updateUrlParameters(Filter/* CourseTypes.UPCOMING */.fz.UPCOMING, Filter/* FilterTypesInUrl.TRAINING_TYPE */.$R.TRAINING_TYPE, '', setSelectedTrainingTypes);
            },
            checked: selectedTrainingTypes !== null && selectedTrainingTypes !== void 0 && selectedTrainingTypes.includes(Filter/* CourseTypes.UPCOMING */.fz.UPCOMING) ? selectedTrainingTypes === null || selectedTrainingTypes === void 0 ? void 0 : selectedTrainingTypes.includes(Filter/* CourseTypes.UPCOMING */.fz.UPCOMING) : false,
            label: "".concat(t("filters.courseType.upcoming"), " (").concat(courseTypeCounts[Filter/* CourseTypes.UPCOMING */.fz.UPCOMING] || 0, ")")
          })
        }), (selectedTrainingTypes === null || selectedTrainingTypes === void 0 ? void 0 : selectedTrainingTypes.includes(Filter/* CourseTypes.UPCOMING */.fz.UPCOMING)) && [Filter/* CourseTypes.ONLINE */.fz.ONLINE, Filter/* CourseTypes.ATTENDANCE */.fz.ATTENDANCE].map(function (courseType, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(InLine, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
              name: courseType,
              onChange: function onChange() {
                return updateUrlParameters(courseType, Filter/* FilterTypesInUrl.TRAINING_TYPE */.$R.TRAINING_TYPE, selectedTrainingTypes, setSelectedTrainingTypes);
              },
              checked: selectedTrainingTypes === null || selectedTrainingTypes === void 0 ? void 0 : selectedTrainingTypes.includes(courseType),
              label: "".concat(t("filters.courseType.".concat(courseType)), " (").concat(courseTypeCounts[courseType] || 0, ")")
            })
          }, key);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, {
            name: Filter/* CourseTypes.ARCHIVED */.fz.ARCHIVED,
            onChange: function onChange() {
              return updateUrlParameters(Filter/* CourseTypes.ARCHIVED */.fz.ARCHIVED, Filter/* FilterTypesInUrl.TRAINING_TYPE */.$R.TRAINING_TYPE, '', setSelectedTrainingTypes);
            },
            checked: selectedTrainingTypes !== null && selectedTrainingTypes !== void 0 && selectedTrainingTypes.includes(Filter/* CourseTypes.ARCHIVED */.fz.ARCHIVED) ? selectedTrainingTypes === null || selectedTrainingTypes === void 0 ? void 0 : selectedTrainingTypes.includes(Filter/* CourseTypes.ARCHIVED */.fz.ARCHIVED) : false,
            label: "".concat(t("filters.courseType.archived"), " (").concat(courseTypeCounts[Filter/* CourseTypes.ARCHIVED */.fz.ARCHIVED] || 0, ")")
          })
        })]
      }), type === Filter/* FilterTypesInResponse.CONFERENCE_TYPE */.N_.CONFERENCE_TYPE && [Filter/* ConferenceTypes.UPCOMING */.sP.UPCOMING, Filter/* ConferenceTypes.ARCHIVED */.sP.ARCHIVED].map(function (conferenceType, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Line, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, {
            name: String(conferenceType),
            onChange: function onChange() {
              updateUrlParameters(String(conferenceType), Filter/* FilterTypesInUrl.CONFERENCE_TYPE */.$R.CONFERENCE_TYPE, null, setSelectedConferenceTypes);
            },
            checked: selectedConferenceTypes === null || selectedConferenceTypes === void 0 ? void 0 : selectedConferenceTypes.includes(String(conferenceType)),
            label: "".concat(t("filters.conferenceType.".concat(conferenceType)), " (").concat(conferenceTypeCounts[conferenceType] || 0, ")")
          })
        }, key);
      })]
    })]
  });
};

/* harmony default export */ var Filter_Filter = (FilterTemplate);

/***/ }),

/***/ 45664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Newsletter; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx + 9 modules
var Modal = __webpack_require__(81579);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Newsletter/Newsletter.elements.tsx




var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__Section",
  componentId: "sc-1bg7qs3-0"
})(["border-radius:", ";border:1px solid ", ";max-width:", ";margin:0 auto;padding:", " ", ";text-align:center;@media (min-width:", "px){padding:", ";}"], (0,polished_esm/* rem */.hO)(16), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.isStaticBanner ? (0,polished_esm/* rem */.hO)(320) : (0,polished_esm/* rem */.hO)(900);
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.isStaticBanner ? (0,polished_esm/* rem */.hO)(20) : (0,polished_esm/* rem */.hO)(30);
});
var Description = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__Description",
  componentId: "sc-1bg7qs3-1"
})(["display:block;font-size:", ";font-weight:", ";padding-bottom:", ";line-height:", ";"], function (prop) {
  return prop.isStaticBanner ? prop.theme.fontSizes.textMedium : prop.theme.fontSizes.h5;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(28));
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__InputSection",
  componentId: "sc-1bg7qs3-2"
})(["position:relative;margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(25));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Newsletterelements__Input",
  componentId: "sc-1bg7qs3-3"
})(["width:100%;height:", ";padding:", ";border-radius:", ";border:1px solid ", ";margin:", " 0;padding-right:", ";&.error{border-color:", ";}"], (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(4), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(60), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.danger;
});
var InputButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Newsletterelements__InputButton",
  componentId: "sc-1bg7qs3-4"
})(["position:absolute;right:", ";top:", ";height:", ";width:", ";cursor:pointer;display:flex;align-items:center;justify-content:center;background:", ";border:none;border-radius:", ";svg{color:", ";}"], (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(46), (0,polished_esm/* rem */.hO)(60), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
});
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__ErrorMessage",
  componentId: "sc-1bg7qs3-5"
})(["margin:0 0 ", " 0;display:block;font-size:", ";color:", ";text-align:left;"], (0,polished_esm/* rem */.hO)(10), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.textBase;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.danger;
});
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__SuccessMessage",
  componentId: "sc-1bg7qs3-6"
})(["margin:0 0 ", " 0;display:block;font-size:", ";color:", ";text-align:left;"], (0,polished_esm/* rem */.hO)(10), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.textBase;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
});
var Social = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__Social",
  componentId: "sc-1bg7qs3-7"
})(["text-align:center;"]);
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Newsletterelements__Link",
  componentId: "sc-1bg7qs3-8"
})(["color:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.black;
});
var Newsletter_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Newsletterelements__Icon",
  componentId: "sc-1bg7qs3-9"
})(["background:", ";margin:", ";border-radius:50%;padding:", " ", ";border:2px solid transparent;cursor:pointer;&:hover{border:2px solid ", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.white;
}, function (prop) {
  return prop.isStaticBanner ? "".concat((0,polished_esm/* rem */.hO)(10), " ").concat((0,polished_esm/* rem */.hO)(4)) : (0,polished_esm/* rem */.hO)(10);
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(8), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.black;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Newsletter/Newsletter.tsx












var NewsletterTemplate = function NewsletterTemplate(_ref) {
  var _ref$isStaticBanner = _ref.isStaticBanner,
      isStaticBanner = _ref$isStaticBanner === void 0 ? false : _ref$isStaticBanner,
      _ref$renderOnlyInput = _ref.renderOnlyInput,
      renderOnlyInput = _ref$renderOnlyInput === void 0 ? false : _ref$renderOnlyInput;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var emailInputRef = (0,react.useRef)();

  var renderInput = function renderInput() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
      onClick: function onClick() {
        return dispatch((0,ui/* openModalType */.$X)({
          type: Modal/* ModalTypes.NEWSLETTER */.Q.NEWSLETTER
        }));
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
        ref: emailInputRef,
        placeholder: t('homepage.newsletter.placeholder')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputButton, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: Icon/* Icons.Send */.PJ.Send,
          width: 30,
          height: 30
        })
      })]
    });
  };

  return renderOnlyInput ? renderInput() : /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    withPadding: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      isStaticBanner: isStaticBanner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: t('homepage.newsletter.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        isStaticBanner: isStaticBanner,
        dangerouslySetInnerHTML: {
          __html: t('homepage.newsletter.description')
        }
      }), renderInput(), /*#__PURE__*/(0,jsx_runtime.jsxs)(Social, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.facebook.com/FiremniVzdelavaniStudioW",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Facebook */.PJ.Facebook
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.linkedin.com/company/studio-w",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Linkedin */.PJ.Linkedin
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.instagram.com/studiow_vzdelavani",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Instagram */.PJ.Instagram
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var Newsletter = (NewsletterTemplate);

/***/ }),

/***/ 45147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Radio/Radio.elements.tsx


var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Radioelements__Wrapper",
  componentId: "sc-12r0wl4-0"
})(["position:relative;margin-bottom:", ";display:flex;align-items:center;"], (0,polished_esm/* rem */.hO)(15));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Radioelements__Input",
  componentId: "sc-12r0wl4-1"
})(["height:", ";left:0;position:absolute;top:0;width:", ";cursor:pointer;&:after{width:", ";height:", ";border-radius:", ";top:0;left:0;position:relative;background-color:", ";content:'';display:inline-block;visibility:visible;border:", " solid ", ";}&:checked:after{width:", ";height:", ";border-radius:", ";top:0;left:0;position:relative;background-color:", ";content:'';display:inline-block;visibility:visible;border:", " solid ", ";}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(1), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(6), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "Radioelements__Label",
  componentId: "sc-12r0wl4-2"
})(["display:block;padding-left:", ";cursor:pointer;font-weight:", ";"], (0,polished_esm/* rem */.hO)(35), function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Radio/Radio.tsx





var RadioTemplate = function RadioTemplate(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      checked = _ref.checked,
      children = _ref.children,
      _ref$isCircle = _ref.isCircle,
      isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle,
      label = _ref.label,
      _ref$isFilterType = _ref.isFilterType,
      isFilterType = _ref$isFilterType === void 0 ? false : _ref$isFilterType,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    isCircle: isCircle,
    isFilterType: isFilterType,
    disabled: disabled,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
      id: "id-".concat(name),
      onChange: onChange,
      checked: checked,
      name: name,
      type: "radio"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
      isBold: isFilterType && checked,
      htmlFor: "id-".concat(name),
      children: children ? children : label
    })]
  });
};

/* harmony default export */ var Radio = (RadioTemplate);

/***/ })

}]);